var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.955.612a3.544 3.544 0 0 1 2.468 2.517c.6 2.236.577 6.895.577 6.895s0 4.635-.577 6.87a3.544 3.544 0 0 1-2.468 2.518C22.765 20 14 20 14 20s-8.741 0-10.956-.612a3.544 3.544 0 0 1-2.467-2.517C0 14.659 0 10 0 10s0-4.635.577-6.87C.9 1.905 1.868.917 3.044.587 5.236 0 14 0 14 0s8.764 0 10.955.612ZM11.21 5.718 18.497 10l-7.288 4.282V5.718Z",
    fill: "#E0E0E0"
  })));
};

export default SvgYoutube;